'use strict';

/**
 * @ngdoc service
 * @name gfcmsApp.scheduleJobs.service
 * @description
 * # scheduleJobs.service
 * Service in the gfcmsApp.
 */
angular.module('gfcmsApp').service('scheduleJobsService', function (moment) {
  var scheduleJobsService = {
    getFirstEventMatching: getFirstEventMatching,
    getAllEventsMatching: getAllEventsMatching,
    updateEventDatesUtc: updateEventDatesUtc
  };

  function getFirstEventMatching(calendarEvents, predicate) {
    return getAllEventsMatching(calendarEvents, predicate)[0];
  }

  function getAllEventsMatching(calendarEvents, predicate) {
    if (!Array.isArray(calendarEvents)) {
      throw new Error('calendarEvents is not an array');
    }

    if (!predicate) {
      throw new Error('predicate is undefined');
    }

    return calendarEvents.filter(function (item) {
      return predicate(item);
    });
  }

  function updateEventDatesUtc(event, start, end) {
    if (!event) {
      throw new Error('event is undefined');
    }

    if (!start) {
      throw new Error('start is undefined');
    }

    if (!end) {
      throw new Error('end is undefined');
    }

    var startDateTime = moment(start).local().format('YYYY-MM-DD HH:mm:ss');
    var endDateTime = moment(end).local().format('YYYY-MM-DD HH:mm:ss');

    event.startDateTime = event.start = startDateTime;
    event.endDateTime = event.end = endDateTime;
    event.startMoment = moment(start);
    event.endMoment = moment(end);
  }

  return scheduleJobsService;
});
